import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withState from './withState'
import withEventHandlers from './withEventHandlers'

// presentational components
import UI from './UI'

// shared higher-order component
const withNewParentForm = options => {
  const { redirect, onSuccess } = options

  const withParentFormResults = withFormResults({
    mutation: 'createParent',
    field: 'parent',
    successMessage: 'Parent added',
    onSuccess,
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withQueryResults,
    withQuery,
    withParentFormResults,
    withMutation,
    withState,
    withEventHandlers
  )
}

// in account manager, redirect to overview
export default withNewParentForm({ redirect: '/' })(UI)

// for registration flow
export { withNewParentForm }
